import { SectionCard, fmtTRY } from '../yeni-design/primitives';
import type { Donem } from './donem';
import type { SaKaynak } from './ekranKaynaklari';
import { useSaSorgu } from './useSatisVerisi';
import { BlokIskeleti } from './BlokIskeleti';
import { UrunKirilimiYok } from './UrunKirilimiYok';
import { yemekKartiSeciliMi } from './kanal';
import { oranMetni } from './bicim';
import { sayi, type Sayisal } from './ozetHesaplari';

interface CokSatanSatiri {
  stok_kodu: string;
  urun_adi: string;
  miktar: Sayisal;
  ciro: Sayisal;
  kar: Sayisal;
}

/**
 * FINAL-FIX F-2: ekranin TEK marj tanimi kar ÷ URUN cirosu (KDV dahil `ciro`; spec §2.5, kâr karti,
 * KategoriBlok, Uyarilar, KarKoprusu). 990053'un `kar_marji` kolonu kar ÷ KDV HARIC tutar — ayni ekranda
 * ikinci bir "Marj" olurdu, OKUNMAZ. Ciro 0 ya da kar yoksa (kart maliyeti NULL) null.
 */
export function urunMarji(r: Pick<CokSatanSatiri, 'ciro' | 'kar'>): number | null {
  const ciro = sayi(r.ciro);
  if (ciro === 0 || r.kar === null || r.kar === undefined) return null;
  return (sayi(r.kar) / ciro) * 100;
}

interface Props {
  kaynak: SaKaynak | undefined;
  donem: Donem;
  sube?: string | null;
  kanal?: string | null;
}

export const COK_SATAN_ILK_N = 5;

/** Satir 3 — en cok satan 5 (990053; ds ciro azalan ilk 20 dondurur, sirasi korunur). */
export function CokSatanBlok({ kaynak, donem, sube = null, kanal = null }: Props) {
  const urunYok = yemekKartiSeciliMi(kanal);
  const q = useSaSorgu<CokSatanSatiri>(kaynak, { donem, sube, kanal }, !urunYok);

  if (!kaynak) return null;
  if (urunYok)
    return (
      <div data-testid="blok-cok-satan">
        <SectionCard title="En çok satan">
          <UrunKirilimiYok />
        </SectionCard>
      </div>
    );
  if (q.isLoading) return <BlokIskeleti testid="blok-cok-satan-iskelet" baslik="En çok satan" yukseklik={180} satir={5} />;
  const satirlar = (q.data?.data ?? []).slice(0, COK_SATAN_ILK_N);
  if (satirlar.length === 0) return null;

  return (
    <div data-testid="blok-cok-satan">
      <SectionCard title="En çok satan" subtitle="Ciroya göre ilk 5">
        <table className="w-full text-[12.5px]">
          <thead>
            <tr className="text-ink-400 text-left">
              <th className="font-normal py-1">Ürün</th>
              <th className="font-normal py-1 text-right">Ciro</th>
              <th className="font-normal py-1 text-right">Marj</th>
            </tr>
          </thead>
          <tbody>
            {satirlar.map((r) => {
              const marj = urunMarji(r);
              return (
                <tr key={r.stok_kodu} data-testid={`cok-satan-satir-${r.stok_kodu}`} className="border-t border-border">
                  <td className="py-1 pr-2 text-ink-800 truncate max-w-0 w-full">{r.urun_adi}</td>
                  <td className="py-1 text-right tnum text-ink-700 whitespace-nowrap">{fmtTRY(sayi(r.ciro))}</td>
                  <td className={`py-1 pl-2 text-right tnum whitespace-nowrap ${marj !== null && marj < 0 ? 'text-neg-700' : 'text-ink-500'}`}>
                    {marj === null ? '—' : oranMetni(marj)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </SectionCard>
    </div>
  );
}
